import React, { FC, ReactChild } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import theme from '@/styles/theme'
import Box from '@/atoms/Box'
import Head from './Head'
import Footer from '@/components/Footer'
import Header from '@/components/Header'
import GlobalStyle from '@/styles/globalStyle'
import { CookiesProvider } from 'react-cookie';
import CookieConsent from '@/components/CookieConsent'


type Props = {
  children: ReactChild | ReactChild[] | JSX.Element
}

const Scroller = styled(Box)`
  scroll-snap-type: x mandatory;
  ${({ theme: { mediaQueries: { small } } }) => small} {
    scroll-snap-type: none;
  }
`;

const onWheel = (e: any) => {
  const container = document.getElementById('container');
  container?.scrollTo({
      top: 0,
      left: container?.scrollLeft + e.deltaY,
      behaviour: 'smooth' //if you want smooth scrolling
  })
}

const Layout: FC<Props> = props => {
  const { children } = props

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <GlobalStyle />
        <CookieConsent />
        <Scroller
          color="black"
          bg="grey"
          onWheel={(e) => onWheel(e)} id="container"
          overflowX="scroll"
        >
          <Head />
          <Header />
          {children}
          <Footer />
        </Scroller>
      </CookiesProvider>
    </ThemeProvider>
  )
}

export default Layout
